import { options } from "@/global/slick-options";


const galleries = document.querySelectorAll( '.single-gallery' );

galleries.forEach( gallery => {
    const slider = gallery.querySelector( '.single-gallery-main' );
    const thumbs = gallery.querySelector( '.single-gallery-nav' );

    if ( !slider ) return;

    jQuery( slider ).slick( {
        ...options,
        slidesToShow: 1,
        arrows: false,
        fade: true,
        infinite: true,
        asNavFor: thumbs || false
    } );

    if ( thumbs ) {
        jQuery( thumbs ).slick( {
            ...options,
            slidesToShow: 1,
            asNavFor: slider,
            rows: 0,
            centerMode: false,
            infinite: true,
            focusOnSelect: true,
            arrows: false,
            respondTo: 'slider',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                    }
                },
            ]
        } );
    }

    jQuery( slider ).slickLightbox( {
        slick: {
            ...options,
            slidesToShow: 1,
        }
    } );
} );
